<template>
  <div class="form-group">
    <label v-if="label" class="control-label w-100">
      <span>{{ label }}</span>
    </label>

    <el-autocomplete
      v-model="value"
      v-validate="modelValidations.distributor"
      name="distributor"
      :debounce="500"
      :fetch-suggestions="querySearchAsync"
      :placeholder="placeholder + '(*)'"
      :trigger-on-focus="false"
      @select="onSelected"
    ></el-autocomplete>

    <small v-show="searchError !== ''" class="text-danger d-block">
      {{ searchError }}
    </small>

    <small v-show="distributor.invalid" class="text-danger">
      {{ getError('distributor') }}
    </small>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Autocomplete, Select, Option } from 'element-ui';
import remoteAutocompleteMixin from '../../mixins/remoteAutocompleteMixin';

export default {
  components: {
    [Autocomplete.name]: Autocomplete,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [remoteAutocompleteMixin],
  props: {
    label: {
      type: String,
      default: 'Seleccione Distribuidor',
    },

    placeholder: {
      type: String,
      default: 'Seleccione Distribuidor',
    },

    emptyCuitFilter: {
      type: Boolean,
      default: null,
    },

    forSelect: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      value: null,
      selected: null,
      distributors: [],
      modelValidations: {
        distributor: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['distributor']),
  },

  methods: {
    selectOptions() {
      return this.distributors;
    },

    fetchData(query) {
      this.distributors = [];
      const params = { query };

      if (this.emptyCuitFilter !== null) {
        params['empty_cuit'] = this.emptyCuitFilter;
      }

      return this.$services
        .resource('distributors')
        .search(params)
        .then((res) => res.data.data)
        .then((distributors) => {
          this.checkResults(distributors);
          this.distributors = distributors;
        });
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll();
    },

    onSelected(item) {
      this.selected = item.id;
      this.$emit('input', this.selected);
    },

    clearSelection() {
      this.selected = null;
      this.value = null;
    },
  },
};
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>
